import { render } from "./mvt-cardpoi.vue?vue&type=template&id=1cfd04bb"
import script from "./mvt-cardpoi.js?vue&type=script&lang=js"
export * from "./mvt-cardpoi.js?vue&type=script&lang=js"

import "./mvt-cardpoi.vue?vue&type=style&index=0&id=1cfd04bb&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__